import { useLayoutEffect, useRef } from 'react';

import { useLang } from "~/hooks/useLang";
import { setLoginConfig, updateLoginLang } from "~/providers/user";

export default function Badge() {
	const { lang } = useLang();
	const containerRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		setLoginConfig();
		updateLoginLang(lang);

		const node = document.createElement("szn-login-widget");

		if (node) {
			node.setAttribute("notifications", "");
			containerRef.current.appendChild(node);
		}

		return () => {
			containerRef.current.innerHTML = "";
		};
	}, [lang]);

	return <div ref={containerRef}></div>;
}
